var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{},_vm._l((_vm.comments),function(comment,index){return _c('comment',{key:comment.id,attrs:{"auth":_vm.auth,"comment":comment},on:{"answer-comment":_vm.answerComment,"show-auth-modal":function($event){return _vm.$emit('show-auth-modal')}}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }